/**
 * Permission keys of the Companies and branches screen (catalog: legacy menu 4 "Company Info" → `md.company`, menu 310
 * "Store" → `md.branch`). The API checks the same keys (`MasterDataPermissions`).
 */
export const organizationPermissions = {
  companyView: "md.company.view",
  companyCreate: "md.company.create",
  companyUpdate: "md.company.update",
  companyHistory: "md.company.history",
  branchView: "md.branch.view",
  branchCreate: "md.branch.create",
  branchUpdate: "md.branch.update",
} as const;
